import { Modal } from "react-bootstrap";

import styles from "./QRModalWindow.module.css";
import ButtonsBlock from "../../../GeneralComponents/buttonsBlock/ButtonsBlock";
import printJS from "print-js";

export default function QRModalWindow({
  show,
  setShow,
  billId,
  billQRurl,
  onClose,
}) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className={styles["form-header"]}>
        <Modal.Title
          className={styles["form-title"]}
          id="contained-modal-title-vcenter"
        >
          {billId && `Номер счета на оплату: ${billId}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles["form-body"]}>
        <img src={billQRurl} />
        {!billQRurl ? (
          <span>Ожидайте, идёт загрузка</span>
        ) : (
          <span>Отсканируйте для оплаты</span>
        )}
      </Modal.Body>

      <Modal.Footer className={styles["form-footer"]}>
        <ButtonsBlock
          saveBtnText={"Печать"}
          handleSaveBtn={() => printJS({ printable: billQRurl, type: "image" })}
        />
      </Modal.Footer>
    </Modal>
  );
}
